import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate  } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Home from "../Home";

import { Steps, Button, Select } from "antd";
import { Modal, Spinner } from "react-bootstrap";
import Breadcrumb from "../../components/Breadcrumb";
import UltmarcRemarkLabel from "../../components/UltmarcRemarkLabel";
import errorMessages from "../../common/errorMessages";
import {
  fetchCityList,
  getOrganizationCustomerDetails,
  organizationAttributeChange,
} from "./actions";
import {
  customerRequestDetails,
  resubmitChangeRequest,
  editChangeRequest,
} from ".././CustomerRequestStatus/actions";
import {
  fetchSuburbList,
  fetchStreetList,
  getCustomerCode,
} from "../NewCustomerRequest/actions";
import { getPersonInquiryList } from "../PersonCustomer/actions";
import Maintenance from "../Maintenance";

const { Step } = Steps;

/*** 
@purpose : Functional component
@Parameter : {props}
**/
function OrganizationAttributeChange(props) {
  const navigate = useNavigate();
  const [activeEmployeeSearch, setActiveEmployeeSearch] =
    useState("esearch-box lg-box");
  const [lang] = useTranslation("language");
  const [show, setShow] = useState(false);
  const [data, setData] = useState({});
  const [current, setCurrent] = useState(0);
  const [path, setPath] = useState("");
  const [submissionId, setSubmissionId] = useState("");
  const [submissionType, setSubmissionType] = useState("");
  const [maintenance, setMaintenance] = useState(false);
  const [submissionTypeValue, setSubmissionTypeValue] = useState("");
  const [submissionData, setSubmissionData] = useState("");
  const [orgId, setOrgId] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [customerTypeId, setCustomerTypeId] = useState("");
  const [customerTypeName, setCustomerTypeName] = useState("");
  const [kanjiFacilityName, setKanjiFacilityName] = useState("");
  const [kanaFacilityName, setKanaFacilityName] = useState("");
  const [kanjiPharmacistName, setKanjiPharmacistName] = useState("");
  const [kanaPharmacistName, setKanaPharmacistName] = useState("");
  const [kanjiAddressLine, setKanjiAddressLine] = useState("");
  const [kanaAddressLine, setKanaAddressLine] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [prefectureID, setPrefectureID] = useState("");
  const [cityID, setCityID] = useState("");
  const [suburbID, setSuburbID] = useState("");
  const [streetID, setStreetID] = useState("");
  const [prefecture, setPrefecture] = useState("");
  const [city, setCity] = useState("");
  const [suburb, setSuburb] = useState("");
  const [street, setStreet] = useState("");
  const [managementId, setManagementId] = useState("");
  const [managementName, setManagementName] = useState("");
  const [orgNotice, setOrgNotice] = useState("");
  const [telephone, setTelephone] = useState("");
  const [unifiedCustomerCode, setUnifiedCustomerCode] = useState("");
  const [legacyUnifiedCode, setLegacyUnifiedCode] = useState("");
  const [orgUnifiedCustomerCode, setOrgUnifiedCustomerCode] = useState("");
  const [kanjiCustomerName, setKanjiCustomerName] = useState("");
  const [kanaCustomerName, setKanaCustomerName] = useState("");
  const [kanjiRepresentativeName, setKanjiRepresentativeName] = useState("");
  const [kanaRepresentativeName, setKanaRepresentativeName] = useState("");
  const [representativeCode, setRepresentativeCode] = useState("");
  const [numberOfBeds, setNumberOfBeds] = useState("");
  const [openDate, setOpenDate] = useState("");
  const [openDateValue, setOpenDateValue] = useState();
  const [remarks, setRemarks] = useState("");
  const [customerCode, setCustomerCode] = useState("");
  const [acceptanceCode, setAcceptanceCode] = useState("");
  const [ultmarcRecordID, setUltmarcRecordID] = useState("");
  const [requestSubmissionId, setRequestSubmissionId] = useState("");
  const [loading, setLoading] = useState(false);
  const [isScreenLoading, setIsScreenLoading] = useState(true);
  const [representativeLoading, setRepresentativeLoading] = useState(false);
  const [cityLoading, setCityLoading] = useState(false);
  const [suburbLoading, setSuburbLoading] = useState(false);
  const [streetLoading, setStreetLoading] = useState(false);
  const [sortCode, setSortCode] = useState("asc");
  const [sortKanjiName, setSortKanjiName] = useState("asc");
  const [sortKanaName, setSortKanaName] = useState("asc");

  const [customerTypeList, setCustomerTypeList] = useState([]);
  const [prefectureList, setPrefectureList] = useState([]);
  const [suburbList, setSuburbList] = useState([]);
  const [cityData, setCityData] = useState([]);
  const [managementList, setManagementList] = useState([]);
  const [streetList, setStreetList] = useState([]);
  const [representativeList, setRepresentativeList] = useState([]);
  const [specialities, setSpecialities] = useState([]);
  const [specialityList, setSpecialityList] = useState([]);
  const [errors, setErrors] = useState({});
  const [representativeErrors, setRepresentativeErrors] = useState({});
  const routes = [
    {
      name: `${lang("Menu.home")}`,
      path: "/",
    },
    {
      name: `${lang("Menu.organizationCustomer")}`,
      path: "/organizationCustomer",
    },
    {
      name: `${lang("organizationDetails.orgCustomerChangeRequest")}`,
      path: "",
    },
  ];

  useEffect(() => {
    async function fetchOrganizationData() {
      try {
        document.body.classList.add("sidebar-open");
        goBack();
        let id;
        let path;
        let pathname = window.location.pathname;
        path = unescape(pathname).split("/")[1];
        setPath(path);
        let url = window.location.href;
        id = unescape(url).split("?orgId=")[1];
        const custType = sessionStorage.getItem("Customer type");
        const managementBody = sessionStorage.getItem("Management body");
        const prefecture = sessionStorage.getItem("Prefecture");
        const speciality = sessionStorage.getItem("Speciality");
        setCustomerTypeList(JSON.parse(custType));
        setManagementList(JSON.parse(managementBody));
        setPrefectureList(JSON.parse(prefecture));
        setSpecialityList(JSON.parse(speciality));
        if (path === "organizationAttributeChange") {
          const res = await getOrganizationCustomerDetails(id);
          if(res && res[0] && res[0].maintenanceWindowFlag) {
            setMaintenance(true);
          }
          setData(res && res[0] && res[0]);
        let {
          orgCustID,
          unifiedCustomerCode,
          customerType,
          facilityNameKanji,
          facilityNameKana,
          managementBodyType,
          postalCode,
          stateProvince,
          city,
          suburb,
          street,
          addressLineKana,
          address_line_kanji,
          tel,
          representativePersonCode,
          representativePersonNameKana,
          representativePersonNameKanji,
          supervisingPharmacistNameKanji,
          supervisingPharmacistNameKana,
          numberOfBeds,
          plannedOpenDate,
          ultmarcRecordID,
          customerSpecialities,
          remarks,
        } = res[0];
        if (customerSpecialities && customerSpecialities.length > 0) {
          let newState = [];
          for (let index = 0; index < customerSpecialities.length; index++) {
            const serviceOne = customerSpecialities[index];
            newState.push({
              value: serviceOne.medicalSpecialityID,
              label: serviceOne.medical_speciality_name_local,
            });
          }
          setSpecialities(newState);
        }
        handleCustomerCode(customerType[0].custTypeID);
        setOrgId(orgCustID);
        setUnifiedCustomerCode(unifiedCustomerCode ? unifiedCustomerCode : "");
        setLegacyUnifiedCode(unifiedCustomerCode ? unifiedCustomerCode : "");
        setCustomerTypeId(
          customerType && customerType[0].custTypeID
            ? customerType[0].custTypeID
            : ""
        );
        setCustomerTypeName(
          customerType && customerType[0].customerTypeNameLocal
            ? customerType[0].customerTypeNameLocal
            : ""
        );
        setKanjiFacilityName(facilityNameKanji ? facilityNameKanji : "");
        setKanaFacilityName(facilityNameKana ? facilityNameKana : "");
        setManagementId(
          managementBodyType && managementBodyType[0].managementBodyTypeID
            ? managementBodyType[0].managementBodyTypeID
            : ""
        );
        setManagementName(
          managementBodyType && managementBodyType[0].management_body_type_name
            ? managementBodyType[0].management_body_type_name
            : ""
        );
        setPostalCode(postalCode ? postalCode : "");
        setPrefectureID(
          stateProvince && stateProvince[0].stateID
            ? stateProvince[0].stateID
            : ""
        );
        setPrefecture(
          stateProvince && stateProvince[0].stateName
            ? stateProvince[0].stateName
            : ""
        );
        setCityID(city && city[0].cityID ? city[0].cityID : "");
        setCity(city && city[0].cityName ? city[0].cityName : "");
        setSuburbID(suburb && suburb[0].suburbID ? suburb[0].suburbID : "");
        setSuburb(suburb && suburb[0].suburbName ? suburb[0].suburbName : "");
        setStreetID(street && street[0].streetID ? street[0].streetID : "");
        setStreet(street && street[0].streetName ? street[0].streetName : "");
        setKanjiAddressLine(address_line_kanji ? address_line_kanji : "");
        setKanaAddressLine(addressLineKana ? addressLineKana : "");
        setTelephone(tel ? tel : "");
        setRepresentativeCode(
          representativePersonCode ? representativePersonCode : ""
        );
        setKanjiRepresentativeName(
          representativePersonNameKanji ? representativePersonNameKanji : ""
        );
        setKanaRepresentativeName(
          representativePersonNameKana ? representativePersonNameKana : ""
        );
        setKanjiPharmacistName(
          supervisingPharmacistNameKanji ? supervisingPharmacistNameKanji : ""
        );
        setKanaPharmacistName(
          supervisingPharmacistNameKana ? supervisingPharmacistNameKana : ""
        );
        setNumberOfBeds(numberOfBeds ? numberOfBeds : "");
        setOpenDate(plannedOpenDate ? plannedOpenDate : "");
        setUltmarcRecordID(ultmarcRecordID ? ultmarcRecordID : "");
        setRemarks(remarks ? remarks : "");
        } else if (
          path === "organizationRequestResubmit" ||
          path === "organizationRequestEdit"
        ) {
          let body = {
            id: id,
          };
          const res = await customerRequestDetails(body);
          if(res.maintenanceWindowFlag){
            setMaintenance(true);
          }
        let {
          submission_id,
          submission_type,
          submission_data,
          unified_customer_code,
          lagacy_unified_customer_code,
          customer_id,
          customer_type,
          facility_name_kanji,
          facility_name_kana,
          management_body,
          postal_code,
          prefecture,
          city,
          suburb,
          street,
          address_line_kanji,
          address_line_kana,
          tel,
          representative_person_code,
          representative_person_name_kanji,
          representative_person_name_kana,
          supervising_person_name_kanji,
          supervising_person_name_kana,
          number_of_beds,
          planned_open_date,
          specialities,
          remarks,
          ultmarc_reception_code,
          is_ultmarc_data,
        } = res.data;
        let newState = [];
        for (let index = 0; index < specialities.value.length; index++) {
          const serviceOne = specialities.value[index];
          newState.push({
            value: serviceOne.specialityID,
            label: serviceOne.specialityName,
          });
        }
        handleCustomerCode(customer_type.key);
        setIsScreenLoading(false);
        setSpecialities(newState);
        setSubmissionId(
          submission_id && submission_id.value ? submission_id.value : ""
        );
        setSubmissionType(
          submission_type && submission_type.value ? submission_type.value : ""
        );
        setSubmissionTypeValue(
          submission_type && submission_type.value ? submission_type.value : ""
        );
        setSubmissionData(
          submission_data && submission_data.value ? submission_data.value : ""
        );
        setSpecialities(newState);
        setCustomerId(
          customer_id && customer_id.value ? customer_id.value : ""
        );
        setUnifiedCustomerCode(
          unified_customer_code && unified_customer_code.value
            ? unified_customer_code.value
            : ""
        );
        setLegacyUnifiedCode(
          lagacy_unified_customer_code && lagacy_unified_customer_code.value
            ? lagacy_unified_customer_code.value
            : ""
        );
        setCustomerTypeId(
          customer_type && customer_type.key ? customer_type.key : ""
        );
        setCustomerTypeName(
          customer_type && customer_type.value ? customer_type.value : ""
        );
        setKanjiFacilityName(
          facility_name_kanji && facility_name_kanji.value
            ? facility_name_kanji.value
            : ""
        );
        setKanaFacilityName(
          facility_name_kana && facility_name_kana.value
            ? facility_name_kana.value
            : ""
        );
        setManagementId(
          management_body && management_body.key ? management_body.key : ""
        );
        setManagementName(
          management_body && management_body.value ? management_body.value : ""
        );
        setPostalCode(
          postal_code && postal_code.value ? postal_code.value : ""
        );
        setPrefectureID(prefecture && prefecture.key ? prefecture.key : "");
        setPrefecture(prefecture && prefecture.value ? prefecture.value : "");
        setCityID(city && city.key ? city.key : "");
        setCity(city && city.value ? city.value : "");
        setSuburbID(suburb && suburb.key ? suburb.key : "");
        setSuburb(suburb && suburb.value ? suburb.value : "");
        setStreetID(street && street.key ? street.key : "");
        setStreet(street && street.value ? street.value : "");
        setKanjiAddressLine(
          address_line_kanji && address_line_kanji.value
            ? address_line_kanji.value
            : ""
        );
        setKanaAddressLine(
          address_line_kana && address_line_kana.value
            ? address_line_kana.value
            : ""
        );
        setTelephone(tel && tel.value ? tel.value : "");
        setRepresentativeCode(
          representative_person_code && representative_person_code.value
            ? representative_person_code.value
            : ""
        );
        setKanjiRepresentativeName(
          representative_person_name_kanji &&
            representative_person_name_kanji.value
            ? representative_person_name_kanji.value
            : ""
        );
        setKanaRepresentativeName(
          representative_person_name_kana &&
            representative_person_name_kana.value
            ? representative_person_name_kana.value
            : ""
        );
        setKanjiPharmacistName(
          supervising_person_name_kanji && supervising_person_name_kanji.value
            ? supervising_person_name_kanji.value
            : ""
        );
        setKanaPharmacistName(
          supervising_person_name_kana && supervising_person_name_kana.value
            ? supervising_person_name_kana.value
            : ""
        );
        setNumberOfBeds(
          number_of_beds && number_of_beds.value ? number_of_beds.value : ""
        );
        setOpenDate(
          planned_open_date && planned_open_date.value
            ? planned_open_date.value
            : ""
        );
        setRemarks(remarks && remarks.value ? remarks.value : "");
        path === "organizationRequestResubmit" &&
          setAcceptanceCode(
            ultmarc_reception_code &&
              ultmarc_reception_code.response_from_ultmarc
              ? ultmarc_reception_code.response_from_ultmarc
              : ""
          );
        path === "organizationRequestEdit" &&
          setAcceptanceCode(
            ultmarc_reception_code && ultmarc_reception_code.value
              ? ultmarc_reception_code.value
              : ""
          );
        }
      } catch (error) {
        console.error("Error loading organization data:", error);
      } finally {
        setIsScreenLoading(false);
      }
    }
    
    fetchOrganizationData();
  }, []);

  useEffect(() => {
    setOrgNotice(
      props.language === "en"
        ? sessionStorage.getItem("en_org_notice")
        : sessionStorage.getItem("jp_org_notice")
    );
  }, [props.language]);

  /*** 
  @purpose : Go back
  @Parameter : {}
  **/
  const goBack = () => {
    setTimeout(() => {
      window.history.forward();
    }, 0);
  };

  /*** 
  @purpose : Handle customer code
  @Parameter : {id}
  **/
  const handleCustomerCode = async (id) => {
    try {
      let body = {
        customer_type_id: id,
      };

      const res = await getCustomerCode(body);
      setCustomerCode(res && res.data);
    } catch (error) {
      console.error("Error getting customer code:", error);
    }
  };

  /*** 
@purpose : Close modal
@Parameter : {}
**/
  const handleClose = () => setShow(false);

  /*** 
  @purpose : Handle employee search
  @Parameter : {}
  **/
  const handleEmployeeSearch = () => {
    setActiveEmployeeSearch("esearch-box lg-box active");
  };

  /*** 
  @purpose : Close employee search
  @Parameter : {}
  **/
  const closeEmployeeSearch = () => {
    setActiveEmployeeSearch("esearch-box lg-box");
  };

  /*** 
  @purpose : Handle speciality
  @Parameter : {value}
  **/
  const handleSpeciality = (value) => {
    if (value && value.length <= 60) {
      setSpecialities(value);
    } else {
      setSpecialities(specialities);
    }
  };

  /*** 
  @purpose : Handle management
  @Parameter : {value}
  **/
  const handleManagementChange = (value) => {
    if (value) {
      setManagementId(value.value);
      setManagementName(value.label);
    } else {
      setManagementId("");
      setManagementName("");
    }
  };

  /*** 
  @purpose : Handle state change
  @Parameter : {}
  **/
  const handleStateChange = async (value) => {
    setCityID("");
    setCity("");
    setSuburbID("");
    setSuburb("");
    setStreetID("");
    setStreet("");
    if (value) {
      setCityLoading(true);
      let id = value.value;
      setPrefecture(value.label);
      setPrefectureID(id);
      await fetchCityList(id).then((res) => {
        setCityLoading(false);
        let newCity = [];
        for (let index = 0; index < res.length; index++) {
          const cityOne = res[index];
          newCity.push({ value: cityOne.cityID, label: cityOne.cityName });
        }
        setCityData(newCity);
      });
    } else {
      setCityLoading(false);
      setPrefectureID("");
      setPrefecture("");
      setCityID("");
      setCity("");
      setSuburbID("");
      setSuburb("");
      setStreetID("");
      setStreet("");
      setCityData([]);
    }
  };

  /*** 
  @purpose : Handle city change
  @Parameter : {value}
  **/
  const handleCityChange = async (value) => {
    setSuburbID("");
    setSuburb("");
    setStreetID("");
    setStreet("");
    if (value) {
      setSuburbLoading(true);
      setCityID(value.value);
      setCity(value.label);
      await fetchSuburbList({
        stateId: prefectureID,
        cityId: value.value,
      }).then((res) => {
        setSuburbLoading(false);
        let list = [];
        for (let index = 0; index < res.length; index++) {
          const suburb = res[index];
          list.push({ value: suburb.suburbID, label: suburb.suburbName });
        }
        setSuburbList(list);
      });
    } else {
      setSuburbLoading(false);
      setCityID(""); 
      setCity("");
      setSuburbID("");
      setSuburb("");
      setStreetID("");
      setStreet("");
      setSuburbList([]);
    }
  };

  /*** 
  @purpose : Handle suburb change
  @Parameter : {value}
  **/
  const handleSuburbChange = async (value) => {
    setStreetID("");
    setStreet("");
    if (value) {
      setStreetLoading(true);
      setSuburbID(value.value);
      setSuburb(value.label);
      await fetchStreetList({
        stateId: prefectureID,
        cityId: cityID,
        suburbId: value.value,
      }).then((res) => {
        setStreetLoading(false);
        let list = [];
        for (let index = 0; index < res.length; index++) {
          const street = res[index];
          list.push({ value: street.streetID, label: street.streetName });
        }
        setStreetList(list);
      });
    } else {
      setStreetLoading(false);
      setSuburbID(""); 
      setSuburb("");
      setStreetID("");
      setStreet("");
      setStreetList([]);
    }
  };

  /*** 
  @purpose : Handle street change
  @Parameter : {value}
  **/
  const handleStreetChange = async (value) => {
    setStreetID(value?.value ?? null);
    setStreet(value?.label ?? null);
  };

  /*** 
  @purpose : Handle customer type
  @Parameter : {value}
  **/
  const handleCustomerType = (value) => {
    setCustomerTypeId(value?.value ?? null);
    setCustomerTypeName(value?.label ?? null);
  };

  /*** 
  @purpose : Handle open date
  @Parameter : {date}
  **/
  const handleOpenDate = (date) => {
    setOpenDateValue(date);
    if (date) {
      var dateObj = new Date(date),
        mnth = ("0" + (dateObj.getMonth() + 1)).slice(-2),
        day = ("0" + dateObj.getDate()).slice(-2);
      setOpenDate([dateObj.getFullYear(), mnth, day].join("/"));
    } else {
      setOpenDate(null);
    }
  };

  /*** 
  @purpose : Change route
  @Parameter : {e, page}
  **/
  const changeRoute = (e, page) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    navigate(page);
  };

  /*** 
  @purpose : Validate representaive person code inquiry form
  @Parameter : {}
  **/
  const validateRepresentativeForm = () => {
    let isFormValid = true;
    let pattern = new RegExp(/[<.|\n*?>]/);
    let regex = new RegExp(
      /[一-龠]+|[ぁ-ゔ]+|[ァ-ヴー]+|[a-zA-Z0-9]+|[ａ-ｚＡ-Ｚ０-９]+[々〆〤]+/
    );
    let errors = {
      kanjiCustomerName: "",
      kanaCustomerName: "",
    };

    if (kanjiCustomerName && !regex.test(kanjiCustomerName))
      errors.kanjiCustomerName = errorMessages.VALID_KANJI_CUSTOMER_NAME;
    else if (kanjiCustomerName && pattern.test(kanjiCustomerName))
      errors.kanjiCustomerName = errorMessages.VALID_KANJI_CUSTOMER_NAME;
    else errors.kanjiCustomerName = "";

    if (kanaCustomerName && !regex.test(kanaCustomerName))
      errors.kanaCustomerName = errorMessages.VALID_KANA_CUSTOMER_NAME;
    else if (kanaCustomerName && pattern.test(kanaCustomerName))
      errors.kanaCustomerName = errorMessages.VALID_KANA_CUSTOMER_NAME;
    else errors.kanaCustomerName = "";

    if (errors.kanjiCustomerName !== "" || errors.kanaCustomerName) {
      isFormValid = false;
    } else {
      isFormValid = true;
    }
    setRepresentativeErrors(errors);

    return isFormValid;
  };

  /*** 
  @purpose : Validate org attribute change form
  @Parameter : {}
  **/
  const validateForm = () => {
    let isFormValid = true;
    let pattern = new RegExp(/[<.|\n*?>]/);
    let kanaRegex = new RegExp(/^[ｦ-ﾟ -~]+$/);
    let postalCodePattern = new RegExp(/^[0-9]{3}-[0-9]{4}$/);
    let numbers = new RegExp(/^[0-9-]+$/);
    let errors = {
      customerType: "",
      kanjiFacilityName: "",
      kanaFacilityName: "",
      prefecture: "",
      city: "",
      suburb: "",
      street: "",
      kanjiAddressLine: "",
      kanaAddressLine: "",
      telephone: "",
      kanjiRepresentativeName: "",
      kanaRepresentativeName: "",
      kanjiPharmacistName: "",
      kanaPharmacistName: "",
      numberOfBeds: "",
      specialities: "",
      remarks: "",
    };

    if (customerTypeId === "")
      errors.customerType = "errorMessages.PROVIDE_CUSTOMER_TYPE";
    else if (kanjiFacilityName && pattern.test(kanjiFacilityName) === true)
      errors.kanjiFacilityName = "errorMessages.VALID_KANJI_FACILITY_NAME";
    else if (kanjiFacilityName === "")
      errors.kanjiFacilityName = "errorMessages.PROVIDE_KANJI_FACILITY_NAME";
    else errors.kanjiFacilityName = "";

    if (kanaFacilityName && kanaRegex.test(kanaFacilityName) === false)
      errors.kanaFacilityName = "errorMessages.VALID_KANA_FACILITY_NAME";
    else errors.kanaFacilityName = "";

    if (prefectureID == "")
      errors.prefecture = "errorMessages.PROVIDE_PREFECTURE";

    if (cityID == "") errors.city = "errorMessages.PROVIDE_CITY";

    if (suburbID == "") errors.suburb = "errorMessages.PROVIDE_SUBURB";

    if (streetID == "") errors.street = "errorMessages.PROVIDE_STREET";

    if (kanjiAddressLine && pattern.test(kanjiAddressLine))
      errors.kanjiAddressLine = "errorMessages.VALID_KANJI_ADDRESS";

    if (kanaAddressLine && pattern.test(kanaAddressLine))
      errors.kanaAddressLine = "errorMessages.VALID_KANA_ADDRESS";
    else if (kanaAddressLine && kanaRegex.test(kanaAddressLine) === false)
      errors.kanaAddressLine = "errorMessages.VALID_KANA_ADDRESS";

    if (telephone && numbers.test(telephone) === false)
      errors.telephone = "errorMessages.VALID_NUMBER";
    else if (telephone === "")
      errors.telephone = "errorMessages.PROVIDE_NUMBER";
    else errors.telephone = "";

    if (postalCode && postalCodePattern.test(postalCode) === false)
      errors.postalCode = "errorMessages.VALID_POSTAL_CODE";
    else errors.postalCode = "";

    if (
      kanjiRepresentativeName &&
      pattern.test(kanjiRepresentativeName) === true
    )
      errors.kanjiRepresentativeName =
        "errorMessages.VALID_KANJI_REPRESENTATIVE";
    else errors.kanjiRepresentativeName = "";

    if (
      kanaRepresentativeName &&
      kanaRegex.test(kanaRepresentativeName) === false
    )
      errors.kanaRepresentativeName = "errorMessages.VALID_KANA_REPRESENTATIVE";
    else errors.kanaRepresentativeName = "";

    if (kanjiPharmacistName && pattern.test(kanjiPharmacistName) === true)
      errors.kanjiPharmacistName = "errorMessages.VALID_KANJI_PHARMACIST_NAME";
    else errors.kanjiPharmacistName = "";

    if (kanaPharmacistName && kanaRegex.test(kanaPharmacistName) === false)
      errors.kanaPharmacistName = "errorMessages.VALID_KANA_PHARMACIST_NAME";
    else errors.kanaPharmacistName = "";

    if (numberOfBeds && numbers.test(numberOfBeds) === false)
      errors.numberOfBeds = "errorMessages.PROVIDE_NUMBER_OF_BEDS";
    else if (customerCode === "200" && numberOfBeds === "")
      errors.numberOfBeds = "errorMessages.PROVIDE_NUMBER_OF_BEDS";
    else errors.numberOfBeds = "";

    if (specialities.length === 0)
      errors.specialities = "errorMessages.PROVIDE_SPECIALITY";

    if (remarks && pattern.test(remarks) === true)
      errors.remarks = "errorMessages.VALID_REMARKS";

    if (path === "organizationAttributeChange") {
      if (customerCode === "200") {
        if (
          errors.kanjiFacilityName !== "" ||
          errors.kanaFacilityName !== "" ||
          errors.kanaAddressLine !== "" ||
          errors.telephone !== "" ||
          errors.postalCode  !== "" ||
          errors.kanaRepresentativeName !== "" ||
          errors.kanaPharmacistName !== "" ||
          errors.remarks !== "" ||
          errors.numberOfBeds !== "" ||
          errors.specialities
        ) {
          isFormValid = false;
        } else {
          isFormValid = true;
        }
      } else {
        if (
          errors.kanjiFacilityName !== "" ||
          errors.kanaFacilityName !== "" ||
          errors.kanaAddressLine !== "" ||
          errors.telephone !== "" ||
          errors.postalCode  !== "" ||
          errors.kanaRepresentativeName !== "" ||
          errors.kanaPharmacistName !== ""
        ) {
          isFormValid = false;
        } else {
          isFormValid = true;
        }
      }
    } else if (
      path === "organizationRequestEdit" ||
      path === "organizationRequestResubmit"
    ) {
      if (customerCode === "200") {
        if (submissionType === "New") {
          if (
            errors.customerType !== "" ||
            errors.kanjiFacilityName !== "" ||
            errors.kanaFacilityName !== "" ||
            errors.prefecture !== "" ||
            errors.city !== "" ||
            errors.suburb !== "" ||
            errors.street !== "" ||
            errors.kanjiAddressLine !== "" ||
            errors.kanaAddressLine !== "" ||
            errors.telephone !== "" ||
            errors.postalCode  !== "" ||
            errors.kanjiRepresentativeName !== "" ||
            errors.kanaRepresentativeName !== "" ||
            errors.kanjiPharmacistName !== "" ||
            errors.kanaPharmacistName !== "" ||
            errors.numberOfBeds !== "" ||
            errors.specialities ||
            errors.remarks !== ""
          ) {
            isFormValid = false;
          } else {
            isFormValid = true;
          }
        }
        if (submissionType === "Change") {
          if (
            errors.kanjiFacilityName !== "" ||
            errors.kanaFacilityName !== "" ||
            errors.kanaAddressLine !== "" ||
            errors.telephone !== "" ||
            errors.postalCode  !== "" ||
            errors.kanaRepresentativeName !== "" ||
            errors.kanaPharmacistName !== "" ||
            errors.numberOfBeds !== "" ||
            errors.specialities
          ) {
            isFormValid = false;
          } else {
            isFormValid = true;
          }
        }
      } else if (customerCode !== "200") {
        if (submissionType === "New") {
          if (
            errors.customerType !== "" ||
            errors.kanjiFacilityName !== "" ||
            errors.kanaFacilityName !== "" ||
            errors.prefecture !== "" ||
            errors.city !== "" ||
            errors.suburb !== "" ||
            errors.street !== "" ||
            errors.kanjiAddressLine !== "" ||
            errors.kanaAddressLine !== "" ||
            errors.telephone !== "" ||
            errors.postalCode  !== "" ||
            errors.kanjiRepresentativeName !== "" ||
            errors.kanaRepresentativeName !== "" ||
            errors.kanjiPharmacistName !== "" ||
            errors.kanaPharmacistName !== "" ||
            errors.remarks !== ""
          ) {
            isFormValid = false;
          } else {
            isFormValid = true;
          }
        }
        if (submissionType === "Change") {
          if (
            errors.kanjiFacilityName !== "" ||
            errors.kanaFacilityName !== "" ||
            errors.kanaAddressLine !== "" ||
            errors.telephone !== "" ||
            errors.postalCode  !== "" ||
            errors.kanaRepresentativeName !== "" ||
            errors.kanaPharmacistName !== ""
          ) {
            isFormValid = false;
          } else {
            isFormValid = true;
          }
        }
      }
    }

    setErrors(errors);
    return isFormValid;
  };

  /*** 
  @purpose : Get representative list
  @Parameter : {}
  **/
  const getRepresentativeList = async () => {
    setRepresentativeLoading(true);
    if (validateRepresentativeForm()) {
      let body = {
        unifiedCustomerCode: orgUnifiedCustomerCode,
        personNameKanji: kanjiCustomerName,
        personNameKana: kanaCustomerName,
      };
      await getPersonInquiryList(body).then((response) => {
        setRepresentativeLoading(false);
        setRepresentativeList(response.data);
      });
    }
  };

  /*** 
  @purpose : Handle sorting
  @Parameter : {}
  **/
  const handleSortingData = (obj) => {
    /*  obj.column === "legacyUnifiedCustomerCode" && setSortCode(obj.sortOrder); /* SAKAMOTO: AHDD-5861 Ultmarc code change */
    obj.column === "unifiedCustomerCode" && setSortCode(obj.sortOrder);         /* SAKAMOTO: AHDD-5861 Ultmarc code change */
    obj.column === "customerNameLocal" && setSortKanjiName(obj.sortOrder);
    obj.column === "customerNameLocalKana" && setSortKanaName(obj.sortOrder);
    let list = compareBySortedData(obj);
    setRepresentativeList(list);
  };

  /*** 
  @purpose : Compare sorted data
  @Parameter : {}
  **/
  const compareBySortedData = (obj) => {
    const sorted = representativeList.sort((a, b) => {
      const isReversed = obj.sortOrder === "asc" ? 1 : -1;
      let first = a[obj.column] ? a[obj.column] : "";
      let second = b[obj.column] ? b[obj.column] : "";
      return isReversed * first.localeCompare(second);
    });
    return sorted;
  };

  /*** 
  @purpose : Organization attribute change
  @Parameter : {}
  **/
  const orgAttributeChange = async () => {
    setLoading(true);
    let list = [];

    specialities.map((sp) => list.push(sp.value.toString()));
    if (path === "organizationAttributeChange") {
      let body = {
        orgCustID: orgId,
        unified_customer_code: unifiedCustomerCode,
        customer_type: customerTypeId,
        facility_name_kanji: kanjiFacilityName,
        facility_name_kana: kanaFacilityName,
        management_body_type: managementId,
        postal_code: postalCode,
        prefecture: prefectureID,
        city: cityID,
        street: streetID,
        suburb: suburbID,
        address_line_kanji: kanjiAddressLine,
        address_line_kana: kanaAddressLine,
        tel: telephone,
        representative_person_code: representativeCode,
        representative_person_name_kanji: kanjiRepresentativeName,
        representative_person_name_kana: kanaRepresentativeName,
        kanji_pharmacist_name: kanjiPharmacistName,
        kana_pharmacist_name: kanaPharmacistName,
        number_of_beds: numberOfBeds,
        planned_open_date: openDate,
        specialities: list,
        remarks: remarks,
        ultmarcRecordID: ultmarcRecordID,
      };
      await organizationAttributeChange(body).then((response) => {
        if (response.success === true) {
          setLoading(false);
          setRequestSubmissionId(response.id);
          setCurrent(current + 1);
        } else if (response.success === false) {
          setLoading(false);
          setShow(true);
        }
      });
    } else if (path === "organizationRequestResubmit") {
      let body = {
        submission_id: submissionId,
        submission_data: "organization_customer",
        submission_type: submissionType,
        unified_customer_code: unifiedCustomerCode,
        customer_id: customerId ? customerId : 0,
        customer_type: customerTypeId,
        facility_name_kanji: kanjiFacilityName,
        facility_name_kana: kanaFacilityName,
        management_body: managementId,
        postal_code: postalCode,
        prefecture: prefectureID,
        city: cityID,
        street: streetID,
        suburb: suburbID,
        address_line_kanji: kanjiAddressLine,
        address_line_kana: kanaAddressLine,
        tel: telephone,
        representative_person: representativeCode,
        representative_person_name_kanji: kanjiRepresentativeName,
        representative_person_name_kana: kanaRepresentativeName,
        kanji_pharmacist_name: kanjiPharmacistName,
        kana_pharmacist_name: kanaPharmacistName,
        number_of_beds: numberOfBeds,
        planned_open_date: openDate,
        specialities: list,
        remarks: remarks,
        reapplication_acceptance_code: acceptanceCode,
      };
      await resubmitChangeRequest(body).then((response) => {
        if (response.success === true) {
          setLoading(false);
          setRequestSubmissionId(response.id);
          setCurrent(current + 1);
        } else if (response.success === false) {
          setLoading(false);
          setShow(true);
        }
      });
    } else if (path === "organizationRequestEdit") {
      let body = {
        submission_id: submissionId,
        submission_data: "organization_customer",
        submission_type: submissionType,
        unified_customer_code: unifiedCustomerCode,
        customer_id: customerId ? customerId : 0,
        customer_type: customerTypeId,
        facility_name_kanji: kanjiFacilityName,
        facility_name_kana: kanaFacilityName,
        management_body: managementId,
        postal_code: postalCode,
        prefecture: prefectureID,
        city: cityID,
        street: streetID,
        suburb: suburbID,
        address_line_kanji: kanjiAddressLine,
        address_line_kana: kanaAddressLine,
        tel: telephone,
        representative_person: representativeCode,
        representative_person_name_kanji: kanjiRepresentativeName,
        representative_person_name_kana: kanaRepresentativeName,
        kanji_pharmacist_name: kanjiPharmacistName,
        kana_pharmacist_name: kanaPharmacistName,
        number_of_beds: numberOfBeds,
        planned_open_date: openDate,
        specialities: list,
        remarks: remarks,
        reapplication_acceptance_code: acceptanceCode,
      };
      await editChangeRequest(body).then((response) => {
        if (response.success === true) {
          setLoading(false);
          setRequestSubmissionId(response.id);
          setCurrent(current + 1);
        } else if (response.success === false) {
          setLoading(false);
          setShow(true);
        }
      });
    }
  };

  /*** 
  @purpose : Go to next step
  @Parameter : {}
  **/
  const next = () => {
    if (validateForm()) {
      setCurrent(current + 1);
    }
  };

  /*** 
  @purpose : Go to previous step
  @Parameter : {}
  **/
  const prev = () => {
    setCurrent(current - 1);
  };

  const steps = [
    {
      title: `${lang("organizationDetails.custNewChangeRequest")}`,
      content: (
        <React.Fragment>
          <div className="submission-box card shadow-card">
            <div className="card-body">
              <div className="sb-row">
                <div className="sb-label">
                  {lang("customerRequestStatus.submissionType")}
                </div>
                {path === "organizationAttributeChange" ? (
                  <div className="sb-content">
                    <a href="#">{lang("errorMessages.change")}</a>
                  </div>
                ) : (
                  <div className="sb-content">
                    <a href="#">{submissionTypeValue}</a>
                  </div>
                )}
              </div>
              <div className="sb-row">
                <div className="sb-label">
                  {lang("customerRequestStatus.submissionData")}
                </div>
                <div className="sb-content">
                  <a href="#">
                    {lang("customerRequestStatus.organizationCustomer")}
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="warning-box card">
            <div className="card-body">
              {/* <div className="warning-icon">
                 <img src="images/warning.svg" alt="warning" />
              </div> */}
              {/* <h4>{lang("organizationDetails.noticeLabel")}</h4>  */}
              <p className="notice" dangerouslySetInnerHTML={{ __html: orgNotice }} />
            </div>
          </div>
          <div className="card shadow-card">
            <div className="card-header">
              <h4>{lang("organizationDetails.custNewChangeRequest")}</h4>
            </div>
            <div className="card-body">
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("organizationDetails.submissionID")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      value={submissionId ? submissionId : ""}
                      readOnly
                    />
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.unifiedCustomerCode")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      // {/* value={legacyUnifiedCode ? legacyUnifiedCode : ""} /* SAKAMOTO: AHDD-5861 Ultmarc code change */}
                      value={unifiedCustomerCode ? unifiedCustomerCode : ""                  /* SAKAMOTO: AHDD-5861 Ultmarc code change */}
                      readOnly
                    />
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.customerType")}
                    {submissionType === "New" && (
                      <span className="danger">*</span>
                    )}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <Select
                      className="ant-select"
                      options={customerTypeList}
                      onChange={handleCustomerType}
                      placeholder={customerTypeName}
                      disabled={true}
                      allowClear={true}
                      showSearch={
                        customerTypeList && customerTypeList.length > 0
                          ? true
                          : false
                      }
                      labelInValue={true}
                      optionFilterProp="label"
                    />
                    {submissionType === "New" && errors.customerType && (
                      <p className="error-text">
                        {lang(`${errors.customerType}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("OrganizationMenu.kanjiFacilityName")}
                    <span className="danger">*</span>
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      value={kanjiFacilityName}
                      maxLength="100"
                      onChange={(e) => setKanjiFacilityName(e.target.value)}
                    />
                    {errors.kanjiFacilityName && (
                      <p className="error-text">
                        {lang(`${errors.kanjiFacilityName}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("OrganizationMenu.kanaFacilityName")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      value={kanaFacilityName}
                      maxLength="100"
                      onChange={(e) => setKanaFacilityName(e.target.value)}
                    />
                    {errors.kanaFacilityName && (
                      <p className="error-text">
                        {lang(`${errors.kanaFacilityName}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("organizationDetails.managementBody")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <Select
                      className="ant-select"
                      value={{ value: managementId, label: managementName }}
                      options={managementList}
                      onChange={handleManagementChange}
                      placeholder={managementName}
                      allowClear={managementId ? true : false}
                      showSearch={
                        managementList && managementList.length > 0
                          ? true
                          : false
                      }
                      labelInValue={true}
                      optionFilterProp="label"
                    />
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("organizationDetails.postalCode")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      value={postalCode}
                      maxLength="8"
                      onChange={(e) => setPostalCode(e.target.value)}
                    />
                    {errors.postalCode && (
                      <p className="error-text">
                        {lang(`${errors.postalCode}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("parentChildFacilityMaintenance.prefecture")}
                    {submissionType === "New" && (
                      <span className="danger">*</span>
                    )}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <Select
                      className="ant-select"
                      options={prefectureList}
                      onChange={handleStateChange}
                      placeholder={prefecture}
                      value={{ value: prefectureID, label: prefecture }}
                      allowClear={prefectureID ? true : false}
                      showSearch={
                        prefectureList && prefectureList.length > 0
                          ? true
                          : false
                      }
                      labelInValue={true}
                      optionFilterProp="label"
                    />
                    {submissionType === "New" && errors.prefecture && (
                      <p className="error-text">
                        {lang(`${errors.prefecture}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("parentChildFacilityMaintenance.city")}
                    {submissionType === "New" && (
                      <span className="danger">*</span>
                    )}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <Select
                      className="ant-select"
                      options={cityData}
                      onChange={handleCityChange}
                      placeholder={city}
                      loading={cityLoading}
                      value={{ value: cityID, label: city }}
                      allowClear={cityID ? true : false}
                      showSearch={
                        cityData && cityData.length > 0 ? true : false
                      }
                      labelInValue={true}
                      optionFilterProp="label"
                    />
                    {submissionType === "New" && errors.city && (
                      <p className="error-text">{lang(`${errors.city}`)}</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.suburb")}
                    {submissionType === "New" && (
                      <span className="danger">*</span>
                    )}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <Select
                      className="ant-select"
                      options={suburbList}
                      onChange={handleSuburbChange}
                      placeholder={suburb}
                      loading={suburbLoading}
                      value={{ value: suburbID, label: suburb }}
                      allowClear={suburbID ? true : false}
                      showSearch={
                        suburbList && suburbList.length > 0 ? true : false
                      }
                      labelInValue={true}
                      optionFilterProp="label"
                    />
                    {submissionType === "New" && errors.suburb && (
                      <p className="error-text">{lang(`${errors.suburb}`)}</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.street")}
                    {submissionType === "New" && (
                      <span className="danger">*</span>
                    )}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <Select
                      className="ant-select"
                      options={streetList}
                      onChange={handleStreetChange}
                      placeholder={street}
                      loading={streetLoading}
                      value={{ value: streetID, label: street }}
                      allowClear={streetID ? true : false}
                      labelInValue={true}
                      showSearch = {
                          streetList && streetList.length > 0 ? true : false
                      }
                      optionFilterProp="label"
                    />
                    {submissionType === "New" && errors.street && (
                      <p className="error-text">{lang(`${errors.street}`)}</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.kanjiAddressLine")}
                    {submissionType === "New" && (
                      <span className="danger">*</span>
                    )}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      value={kanjiAddressLine}
                      maxLength="100"
                      onChange={(e) => setKanjiAddressLine(e.target.value)}
                    />
                    {submissionType === "New" && errors.kanjiAddressLine && (
                      <p className="error-text">
                        {lang(`${errors.kanjiAddressLine}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("organizationDetails.kanaAddressLine")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      value={kanaAddressLine}
                      maxLength="100"
                      onChange={(e) => setKanaAddressLine(e.target.value)}
                    />
                    {errors.kanaAddressLine && (
                      <p className="error-text">
                        {lang(`${errors.kanaAddressLine}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("OrganizationMenu.tel")}
                    {submissionType === "New" && (
                      <span className="danger">*</span>
                    )}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      value={telephone}
                      maxLength="15"
                      onChange={(e) => setTelephone(e.target.value)}
                    />
                    { errors.telephone && (
                      <p className="error-text">
                        {lang(`${errors.telephone}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.representativePersonCode")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="mrs-main">
                    <div className="mrs-box">
                      <label className="select-mrs">{representativeCode}</label>
                      <div>
                        {representativeCode && (
                          <button
                            className="cancel"
                            onClick={() => setRepresentativeCode("")}
                          >
                            X
                          </button>
                        )}
                        <button
                          className="btn btn-primary"
                          onClick={handleEmployeeSearch}
                        >
                          {lang("Buttons.select")}
                        </button>
                      </div>
                    </div>
                    <div className={activeEmployeeSearch}>
                      <div className="row">
                        <div className="col-md-9">
                          <div className="form-group inline-input lg">
                            <label>
                              {lang("organizationDetails.unifiedCustomerCode")}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={orgUnifiedCustomerCode}
                              onChange={(e) =>
                                setOrgUnifiedCustomerCode(e.target.value)
                              }
                            />
                          </div>
                          <div className="form-group inline-input lg">
                            <label>
                              {lang("organizationDetails.kanjiCustomerName")}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={kanjiCustomerName}
                              maxLength="100"
                              onChange={(e) =>
                                setKanjiCustomerName(e.target.value)
                              }
                            />
                            <p className="error-text">
                              {representativeErrors.kanjiCustomerName}
                            </p>
                          </div>

                          <div className="form-group inline-input lg">
                            <label>
                              {lang("organizationDetails.kanaCustomerName")}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={kanaCustomerName}
                              maxLength="100"
                              onChange={(e) =>
                                setKanaCustomerName(e.target.value)
                              }
                            />
                            <p className="error-text">
                              {representativeErrors.kanaCustomerName}
                            </p>
                          </div>
                        </div>
                        <div className="col-12 mb-4">
                          <button
                            className="btn btn-primary"
                            onClick={getRepresentativeList}
                            disabled={representativeLoading}
                          >
                            {lang("Buttons.apply")}
                          </button>
                        </div>
                      </div>
                      {representativeList && representativeList.length > 0 && (
                        <>
                          <p className="record-total">
                            {lang(
                              "territoryDefinitionMaintenance.totalRecords"
                            )}{" "}
                            -{representativeList.length}
                          </p>
                          <div className="table-responsive esearch-table">
                            <table className="table" aria-describedby="table">
                              <thead>
                                <tr>
                                  <th scope="col"></th>
                                  <th
                                    scope="col"
                                    onClick={() =>
                                      handleSortingData({
                                        /*                                      column: "legacyUnifiedCustomerCode", /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                        column: "unifiedCustomerCode",         /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                        sortOrder:
                                          sortCode === "desc" ? "asc" : "desc",
                                      })
                                    }
                                  >
                                    <div className="cursor-pointer">
                                      {lang(
                                        "organizationDetails.unifiedCustomerCode"
                                      )}
                                      <em className="bx bxs-sort-alt"></em>
                                    </div>
                                  </th>
                                  <th
                                    scope="col"
                                    onClick={() =>
                                      handleSortingData({
                                        column: "customerNameLocal",
                                        sortOrder:
                                          sortKanjiName === "desc"
                                            ? "asc"
                                            : "desc",
                                      })
                                    }
                                  >
                                    <div className="cursor-pointer">
                                      {lang(
                                        "organizationDetails.kanjiCustomerName"
                                      )}
                                      <em className="bx bxs-sort-alt"></em>
                                    </div>
                                  </th>
                                  <th
                                    scope="col"
                                    onClick={() =>
                                      handleSortingData({
                                        column: "customerNameLocalKana",
                                        sortOrder:
                                          sortKanaName === "desc"
                                            ? "asc"
                                            : "desc",
                                      })
                                    }
                                  >
                                    <div className="cursor-pointer">
                                      {lang("OrganizationMenu.customerType")}
                                      <em className="bx bxs-sort-alt"></em>
                                    </div>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {representativeList &&
                                  representativeList.map((item, index) => {
                                    return (
                                      <tr key={index}>
                                        <td>
                                          <button
                                            className="btn btn-primary"
                                            onClick={() =>
                                              setRepresentativeCode(
                                                /*                                              item.legacyUnifiedCustomerCode /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                                item.unifiedCustomerCode         /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                              )
                                            }
                                          >
                                            {lang("Buttons.select")}
                                          </button>
                                        </td>
                                        <td>
                                          {/* SAKAMOTO: Ultmarc code change Start */}
                                          {/* item.legacyUnifiedCustomerCode /* SAKAMOTO: AHDD-5861 Ultmarc code change */}
                                          {item.unifiedCustomerCode          /* SAKAMOTO: AHDD-5861 Ultmarc code change */}
                                          {/* SAKAMOTO: Ultmarc code change End */}
                                        </td>
                                        <td>{item.customerNameLocal}</td>
                                        <td>{item.customerTypeNameLocal}</td>
                                      </tr>
                                    );
                                  })}
                              </tbody>
                            </table>
                          </div>
                        </>
                      )}
                      {representativeLoading && <Spinner animation="border" />}
                      <div className="mt-2 text-right">
                        <button
                          className="btn btn-primary"
                          onClick={closeEmployeeSearch}
                        >
                          {lang("Buttons.close")}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.kanjiRepresentativePerson")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      value={kanjiRepresentativeName}
                      maxLength="40"
                      onChange={(e) =>
                        setKanjiRepresentativeName(e.target.value)
                      }
                    />
                    {errors.kanjiRepresentativeName && (
                      <p className="error-text">
                        {lang(`${errors.kanjiRepresentativeName}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.kanaRepresentativePerson")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      value={kanaRepresentativeName}
                      maxLength="20"
                      onChange={(e) =>
                        setKanaRepresentativeName(e.target.value)
                      }
                    />
                    {errors.kanaRepresentativeName && (
                      <p className="error-text">
                        {lang(`${errors.kanaRepresentativeName}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("OrganizationMenu.kanjiPharmacist")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      onChange={(e) => setKanjiPharmacistName(e.target.value)}
                      value={kanjiPharmacistName}
                      maxLength="40"
                    />
                    {errors.kanjiPharmacistName && (
                      <p className="error-text">
                        {lang(`${errors.kanjiPharmacistName}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("OrganizationMenu.kanaPharmacist")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      onChange={(e) => setKanaPharmacistName(e.target.value)}
                      value={kanaPharmacistName}
                      maxLength="20"
                    />
                    {errors.kanaPharmacistName && (
                      <p className="error-text">
                        {lang(`${errors.kanaPharmacistName}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.numberOfBeds")}
                    {customerCode === "200" && (
                      <span className="danger">*</span>
                    )}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      maxLength="4"
                      value={numberOfBeds}
                      onChange={(e) => setNumberOfBeds(e.target.value)}
                    />
                    {errors.numberOfBeds && (
                      <p className="error-text">
                        {lang(`${errors.numberOfBeds}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("organizationDetails.plannedOpenDate")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <DatePicker
                      selected={openDateValue}
                      value={openDate}
                      className="form-control"
                      onChange={(date) => handleOpenDate(date)}
                      style={{ display: "block" }}
                      isClearable
                    />
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.specialities")}
                    {customerCode === "200" && (
                      <span className="danger">*</span>
                    )}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <Select
                      mode="multiple"
                      value={specialities}
                      options={specialityList}
                      showSearch={
                        specialityList && specialityList.length > 0
                          ? true
                          : false
                      }
                      onChange={handleSpeciality}
                      labelInValue={true}
                      optionFilterProp="label"
                    />
                    <p>Please select upto 60 specialities</p>
                    {customerCode === "200" && errors.specialities && (
                      <p className="error-text">
                        {lang(`${errors.specialities}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label className="ultmarc-contact-note-label">
                    <UltmarcRemarkLabel />
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <textarea
                      className="form-control"
                      value={remarks}
                      maxLength="200"
                      onChange={(e) => setRemarks(e.target.value)}
                    ></textarea>
                    {errors.remarks && (
                      <p className="error-text">{lang(`${errors.remarks}`)}</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.reapplicationAcceptanceCode")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      value={acceptanceCode ? acceptanceCode : ""}
                      readOnly
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ),
    },
    {
      title: `${lang("organizationDetails.confirmationLabel")}`,
      content: (
        <React.Fragment>
          <div className="card shadow-card">
            <div className="card-header">
              <h4>{lang("organizationDetails.confirmationLabel")}</h4>
            </div>
            <div className="card-body">
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("customerRequestStatus.submissionType")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {lang("errorMessages.change")}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("customerRequestStatus.submissionData")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {lang("customerRequestStatus.organizationCustomer")}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("organizationDetails.submissionID")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {submissionId ? submissionId : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.unifiedCustomerCode")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {/* legacyUnifiedCode ? legacyUnifiedCode : "" /* SAKAMOTO: AHDD-5861 Ultmarc code change */}
                    {unifiedCustomerCode ? unifiedCustomerCode : ""                /* SAKAMOTO: AHDD-5861 Ultmarc code change */}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.customerType")}
                    {submissionType === "New" && (
                      <span className="danger">*</span>
                    )}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {customerTypeName ? customerTypeName : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("OrganizationMenu.kanjiFacilityName")}
                    {submissionType === "New" && (
                      <span className="danger">*</span>
                    )}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {kanjiFacilityName ? kanjiFacilityName : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("OrganizationMenu.kanaFacilityName")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {kanaFacilityName ? kanaFacilityName : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("organizationDetails.managementBody")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {managementName ? managementName : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("organizationDetails.postalCode")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {postalCode ? postalCode : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("parentChildFacilityMaintenance.prefecture")}
                    {submissionType === "New" && (
                      <span className="danger">*</span>
                    )}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {prefecture ? prefecture : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("parentChildFacilityMaintenance.city")}
                    {submissionType === "New" && (
                      <span className="danger">*</span>
                    )}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {city ? city : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.suburb")}
                    {submissionType === "New" && (
                      <span className="danger">*</span>
                    )}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {suburb ? suburb : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.street")}{" "}
                    {submissionType === "New" && (
                      <span className="danger">*</span>
                    )}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {street ? street : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.kanjiAddressLine")}
                    {submissionType === "New" && (
                      <span className="danger">*</span>
                    )}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {kanjiAddressLine ? kanjiAddressLine : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("organizationDetails.kanaAddressLine")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {kanaAddressLine ? kanaAddressLine : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("OrganizationMenu.tel")}
                    {submissionType === "New" && (
                      <span className="danger">*</span>
                    )}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {telephone ? telephone : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.representativePersonCode")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {representativeCode ? representativeCode : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.kanjiRepresentativePerson")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {kanjiRepresentativeName ? kanjiRepresentativeName : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.kanaRepresentativePerson")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {kanaRepresentativeName ? kanaRepresentativeName : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("OrganizationMenu.kanjiPharmacist")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {kanjiPharmacistName ? kanjiPharmacistName : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("OrganizationMenu.kanaPharmacist")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {kanaPharmacistName ? kanaPharmacistName : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.numberOfBeds")}
                    {customerCode === "200" && (
                      <span className="danger">*</span>
                    )}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {numberOfBeds ? numberOfBeds : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("organizationDetails.plannedOpenDate")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {openDate ? openDate : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.specialities")}
                    {customerCode === "200" && (
                      <span className="danger">*</span>
                    )}
                  </label>
                </div>
                <div className="custom-9">
                  {specialities &&
                    specialities.map((sp, index) => {
                      return (
                        <div key={index} className="value-label color-dark">{sp.label}</div>
                      );
                    })}
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label className="ultmarc-contact-note-label">
                    <UltmarcRemarkLabel />
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {remarks ? remarks : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.reapplicationAcceptanceCode")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label">
                    {acceptanceCode ? acceptanceCode : ""}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ),
    },
    {
      title: `${lang("organizationDetails.completedLabel")}`,
      content: (
        <React.Fragment>
          <div className="submission-box card shadow-card">
            <div className="card-header">
              <h4>{lang("organizationDetails.completedLabel")}</h4>
            </div>
            <div className="card-body">
              <p className="mb-3">
                {lang("errorMessages.REQUEST_SUBMITTED")}
                <span className="subm-title">
                  {lang("organizationDetails.submissionID")} :{" "}
                  {requestSubmissionId}
                </span>
              </p>
              <p className="mb-3">
                {lang("errorMessages.VIEW_SUBMISSION_STATUS")}
                <a
                  className="link"
                  onClick={(e) => {
                    changeRoute(e, "/customerRequestStatus");
                  }}
                >
                  {" "}
                  {lang("Menu.customerRequestStatus")}
                </a>
              </p>
            </div>
          </div>
        </React.Fragment>
      ),
    },
  ];

  return (
    <Home>
      {maintenance ? (
        <Maintenance />
      ) : (
      <>
      <Breadcrumb routes={routes} />
      {isScreenLoading ? (
        <Spinner animation="border" />
      ) : (
        <>
          <Steps current={current}>
            {steps.map((item, index) => (
              <Step key={index} title={item.title} />
            ))}
          </Steps>
          <div className="steps-content horizon-form-lg">
            {steps[current].content}
          </div>
          <div className="steps-action">
            {loading && <Spinner animation="border" />}
            {current > 0 && current < 2 && (
              <Button
                style={{ margin: "0 12px" }}
                disabled={loading}
                onClick={() => prev()}
              >
                {lang("Buttons.previous")}
              </Button>
            )}
            {current < 2 && (
              <Button
                type="primary"
                onClick={() => (current < 1 ? next() : orgAttributeChange())}
                disabled={loading}
              >
                {current < 1
                  ? `${lang("Buttons.next")}`
                  : `${lang("Buttons.submit")}`}
              </Button>
            )}
          </div>
          <Modal
            size="md"
            className="withdraw-modal"
            show={show}
            onHide={handleClose}
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Body>
              <div className="warning-msg">
                {lang("errorMessages.REQUEST_NOT_SUBMITTED")}
              </div>
              <div className="buttons-group">
                <button className="btn btn-primary" onClick={handleClose}>
                  {lang("Buttons.ok")}
                </button>
              </div>
            </Modal.Body>
          </Modal>
        </>
      )}
      </>)}
    </Home>
  );
}

const mapStateToProps = (state) => {
  return {
    details: state.organizationCustomer.orgDetails,
    language: state.organizationCustomer.language,
  };
};

export default connect(mapStateToProps, { getOrganizationCustomerDetails })(
  OrganizationAttributeChange
);
